export enum ExperimentVariant {
    VARIANT_A = 'A',
    VARIANT_B = 'B',
    VARIANT_C = 'C',
    VARIANT_D = 'D',
}

export const GrowthBookFeature = {
    REVIEW_FEATURE_FLAG: 'GTC-2380',
    UNREAD_FEATURE_FLAG: 'GTC-2379',
    FORGOTTEN_PASSWORD_FLAG: 'GTC-2643',
    LOGOUT_TO_BFF: 'GTCON-20',
    EXPIRED_ADS_BANNER: 'GTS-74',
    MCUFEED_CTA_CHANGE: 'GTCON-91',
    DATE_OF_BIRTH_INPUT: 'GTCON-42',
    HIDE_SMS: 'GTCON-274',
    NEW_FEATURES_COPY: 'GTS-142',
    LISTING_CAP_MODAL: 'GTS-105',
    REVEAL_NUMBER_LABEL: 'GTCON-331',
    POSTCODE_INPUT: 'GTCON-275',
    GOOGLE_REVIEW_SRP: 'google-review-srp',
    GBG_VERIFY: 'gbg-verify',
    // sug search
    SUG_WITHOUT_CATEGORY: 'sug_without_category',
    BLOCKTHROUGH_JS: 'blockthrough-ad-script',
    PRE_AD_SOURCE: 'pre-ad-source',
    PREBID_TIMEOUT: 'prebid-timeout',
    NEW_MAKE_OFFER: 'e_001',
    AD_PLACEHOLDER: 'bid02',
    NEXX360_BIDDERS: 'bid03',
    BID04: 'bid04',
    LOGIN_APPLE: 'login01',
    // for sale listing caps
    FEATURE_AD_OPTIMISATION: 'feature-ad-optimisation',
    NEARBY_LISTING_NEW_ADS: 'nearby-listing-new-ads',
    CONSENT_2: 'consent_2',
    VALUE_BANNER: 'value_banner',
    SYI_INTL_SKIN: 'GT_OK_POST_ALIGN',
    // motorway
    MTWAY: 'mtway',
    // services landing
    E_002: 'e_002',
    ADSENSE_QUERY: 'adsense-query',
    INVOKE_1: 'invoke1',
    SRP_1: 'srp1',
    SRP_2: 'srp2',
    SRP_3: 'srp3',
    SRP_4: 'srp4',
    SRP_5: 'srp5',
    SRP_6: 'srp6',
    SRP_7: 'srp7',
    MUL3_1: 'Mul-M',
    CFO: 'CFO',
    // pro account manage ads
    PRO_ACCOUNT_MANAGE_ADS: 'pmads',
    GAM02: 'GAM02',
    AD01: 'ad01',
    AD02: 'ad02',
    AD03: 'ad03',
    AD04: 'ad04',
    AD02_2S: 'ad02_2s',
    /** City landing page: A = original list page, B = new city list page (5 cities). */
    SEO_C_H: 'seo-c-h',
    /** SRP related links (link recommender): A = legacy boxed inline list, B = flat 3-col grid + ellipsis. */
    SEO_L_V2: 'seo-l-v2',
    AI_FLOW_WEB: 'GT_AI_POST_WEB',
    PAY_AND_COLLECT: 'GT-240',
    SRP_CARS_REDESIGN: 'SRP02M',
    SRP_TWO_COLUMNS_REDESIGN: 'SRP-01M',
    SRP_PETS_REDESIGN: 'SRP03M',
    SRP_PROPERTY_REDESIGN: 'SRP04',
    CARS_LANDING_PAGE: 'CLP-M',
    /** GT Services guest lead: A = login required, B = direct to reply-message */
    SER001: 'lpflg',
    MHC: 'MHC',
    WHC: 'WHC',
    ANYVAN_DEEP_INTEGRATION: 'AV002',
    MOTORS_GUEST: 'lpflgm',
    MHH: 'MHH',
    VIP_M: 'VIP-M',
    VIP_PC: 'VIP-PC',
    SRP_RH_PC_FRAME: 'RH-PC1',
    SRP_RH_PC_CARD: 'RH-PC2',
    SRP_RH_MOBILE_CARD: 'RH-SRP',
    SYI_NEXT_WEB: 'GT_AI_POST_OPT',
} as const;

// These server side features are in the whitelist, will do two things:
// 1. pass to the server side, by header key experiments, value is the result of joinExperimentsToString(growthBook), which check each feature is default.
// 2. send experiment_viewed event to GA4 on the client side
export const GrowthBookServerSideFeatures = {
    ANYVAN_DEEP_INTEGRATION: 'AV002',
    SELL_ANOTHER_ITEM: 'GT2131',
    KEYWORD_CORRECTION: 'GTF-2399',
    SUG_USE_NEW_RANK: 'sug_use_new_rank',
    SRP_ENTITY_RANK: 'srp_entity_rank',
    SRP_ENTITY_RECALL: 'srp_entity_recall',
    SRP_VIP_RANK: 'srp_vip_rank',
    SRP_VIP_RECALL: 'srp_vip_recall',
    SRP_RANK_PHASE2: 'srp_rank_phase2',
    SRP_RECALL_PHASE2: 'srp_recall_phase2',
    SRP_LOCATION_RECALL2: 'srp1',
    SRP2: 'srp2',
    SRP3: 'srp3',
    SRP4: 'srp4',
    SRP5: 'srp5',
    SRP6: 'srp6',
    SRP7: 'srp7',
    SHARE_ICON: 'sharead',
    ADES: 'ades',
    MUL3_1: 'Mul-M',
    CFO: 'CFO',
    // bark synonym search
    BARK_SYNONYM_SEARCH: 'Bark-Synonym-Search',
    BK_TOC_EXP: 'Bk-ToC-Exp',
    GT_AI_POST_LITE: 'GT_AI_POST_LITE',
    GT2575_NEW_IM: 'gt2575-new-im',
} as const;
